import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getChequeoProveedoresConfig = (barrioId, administracionId) =>
  axios.get(`${HOST_API}api/chequeoProveedores/getConfig`, {
    params: { barrioId, administracionId },
  });

export const saveChequeoProveedoresConfig = (payload) =>
  axios.post(`${HOST_API}api/chequeoProveedores/saveConfig`, payload);

export const getChequeoProveedoresPendientes = (administracionId, barrioIds) =>
  axios.get(`${HOST_API}api/chequeoProveedores/getPendientes`, {
    params: { administracionId, barrioIds: barrioIds.join(",") },
  });

export const aceptarChequeoProveedores = (barrioId, administracionId, usuarioId) =>
  axios.post(`${HOST_API}api/chequeoProveedores/aceptar`, {
    barrioId,
    administracionId,
    usuarioId,
  });

export const getChequeoProveedoresHistorial = (barrioId, administracionId, desde, hasta) =>
  axios.get(`${HOST_API}api/chequeoProveedores/historial`, {
    params: { barrioId, administracionId, desde, hasta },
  });
